module.exports = __webpack_public_path__ + "static/16-fd48a0ab7311ac36e1d267e110b19b69.jpg";